import React, { useEffect, useState } from 'react';
import api from '../api';

export default function CashBalance() {

  const [balance, setBalance] = useState(0);

  const loadBalance = async () => {

    try {

      const res = await api.get('/transactions/cash-balance/1');

      setBalance(res.data.balance);

    } catch (err) {

      console.error(err);

    }

  };

  useEffect(() => {

    loadBalance();

  }, []);

  return (

    <div
      style={{
        padding: "10px",
        marginBottom: "20px",
        background: "#f5f5f5"
      }}
    >

      <strong>Cash portefeuille :</strong> {balance} €

    </div>

  );

}
